import React, { useState } from 'react';
import { apiError } from '../../../../lib/host';
import { useT } from '../../../../lib/i18n';
import { ErrorBanner, Modal } from '../../ui';

/** Asks for the person's password before a security change, then runs `action(password)`. */
export default function PasswordModal({ title, message, confirmLabel, danger, extra, onConfirm, onClose }) {
  const { t } = useT();
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await onConfirm(password);
    } catch (err) {
      setError(apiError(err, t('Something went wrong. Please try again.')));
      setBusy(false);
    }
  };
  return (
    <Modal title={title} onClose={onClose}>
      <form className="st-modal-form" onSubmit={submit}>
        {message && <p className="st-muted">{message}</p>}
        <ErrorBanner message={error} />
        {extra}
        <label className="field">{t('Your password')}
          <input type="password" autoComplete="current-password" value={password} autoFocus required onChange={(e) => setPassword(e.target.value)} />
        </label>
        <div className="st-modal-actions">
          <button type="button" className="secondary-action" onClick={onClose}>{t('Cancel')}</button>
          <button className={danger ? 'st-danger-button' : 'primary-action'} disabled={busy || !password}>{busy ? t('Please wait…') : confirmLabel}</button>
        </div>
      </form>
    </Modal>
  );
}
